<template>
	<div class="Prodoctthird">
		<div class="Prodoctthird-top">
			<img :src="topimg" class="image-width" alt="" />
			<div class="Prodoctthird-introduce">
				<div
					class="Prodoctthird-introduce-line"
					v-for="(item, index) in producelist"
					:key="index"
				>
					<div
						class="introduce-line-left"
						:class="{ 'introduce-line-left--en': lang === 'en' }"
					>
						{{ item.name }}
					</div>
					<div class="introduce-line-right">
						{{ item.text }}
					</div>
				</div>
			</div>
		</div>
		<div class="Prodoctsec-top-select">
			<van-dropdown-menu
				active-color="#1989fa"
				class="top-select-dorp"
				:overlay="false"
			>
				<van-dropdown-item ref="item">
					<template #title>
						<div class="dorp-item-title">
							<div class="item-title-left van-ellipsis">
								{{ getLangText(selitem, 'name') }}
							</div>
							<div class="item-title-right">
								<div class="title-right-down"></div>
							</div>
						</div>
					</template>
					<template #default>
						<div class="dorp-item-selbox">
							<div
								class="item-selbox-item"
								v-for="(item, index) in prothirdlist"
								:key="index"
								@click="Selsecpro(item)"
							>
								{{ getLangText(item, 'name') }}
							</div>
						</div>
					</template>
				</van-dropdown-item>
			</van-dropdown-menu>
		</div>
		<div class="Prodoctthird-infobox">
			<div class="Prodoctthird-infobox-left">
				<div class="infobox-left-img">
					<img :src="selitem.iconSJ" class="image-width" alt="" />
				</div>
			</div>
			<div class="Prodoctthird-infobox-rig">
				<div class="infobox-rig-con">
					<div class="rig-con-title">{{ getLangText(selitem, 'name') }}</div>
					<div class="rig-con-line"></div>
					<div class="rig-con-box">
						<div class="con-box-line" v-if="selitem.apply">
							<div
								class="box-line-title"
								:class="{ 'box-line-title--en': lang === 'en' }"
							>
								{{ $t('应用') }}:
							</div>
							<div class="box-line-text">
								{{ getLangText(selitem, 'apply') }}
							</div>
						</div>
						<div class="con-box-line" v-if="selitem.structure">
							<div
								class="box-line-title"
								:class="{ 'box-line-title--en': lang === 'en' }"
							>
								{{ $t('结构') }}:
							</div>
							<div class="box-line-text">
								{{ getLangText(selitem, 'structure') }}
							</div>
						</div>
						<div class="con-box-line" v-if="selitem.feature">
							<div
								class="box-line-title"
								:class="{ 'box-line-title--en': lang === 'en' }"
							>
								{{ $t('特性') }}:
							</div>
							<div class="box-line-text">
								{{ getLangText(selitem, 'feature') }}
							</div>
						</div>
						<div class="con-box-line" v-if="selitem.advantage">
							<div
								class="box-line-title"
								:class="{ 'box-line-title--en': lang === 'en' }"
							>
								{{ $t('优势') }}:
							</div>
							<div class="box-line-text">
								<ul class="line-text-ul">
									<li
										class="text-ul-lix"
										v-for="(item, index) in getLangText(
											selitem,
											'advantage'
										).split('#')"
										:key="index"
									>
										{{ index + 1 + '. ' + item }}
									</li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="Prodoctthird-logobox">
			<div class="Prodoctthird-logobox-img">
				<img
					:src="require('@/assets/images/productsec-arrow.png')"
					class="image-width"
					alt=""
				/>
			</div>
			<div class="Prodoctthird-logobox-text">{{ $t('产品种类') }}</div>
		</div>
		<div class="Prodoctthird-con">
			<div
				class="Prodoctthird-con-item"
				:class="{
					'Prodoctthird-con-item--leaf': !canNavigateFromThirdItem(item)
				}"
				v-for="(item, index) in profourlist"
				:key="index"
				@click="Todetail(item)"
			>
				<div class="con-item-img">
					<img :src="item.iconSJ || item.icon" class="image-width" alt="" />
				</div>
				<div class="con-item-text">{{ getLangText(item, 'name') }}</div>
			</div>
		</div>
	</div>
</template>

<script>
import { getProductList } from '@/api';
import { canNavigateFromThirdItem as canNavigateFromThirdItemUtil } from '@/utils/product';

export default {
	name: 'Prodoctthird',
	data() {
		return {
			producelist: [
				{
					name: this.$t('名称'),
					text: ''
				},
				{
					name: this.$t('简介'),
					text: ''
				},
				{
					name: this.$t('应用'),
					text: ''
				}
			],
			prothirdlist: [],
			profourlist: [],
			selitem: JSON.parse(localStorage.getItem('productThirdItem')),
			topimg: ''
		};
	},
	beforeRouteLeave(to, from, next) {
		if (['Prodoctfour'].indexOf(to.name) > -1) {
			this.$store.commit('setKeepAlive', ['Prodoctsec', 'Prodoctthird']);
		} else if (['Prodoctsec'].indexOf(to.name) > -1) {
			this.$store.commit('setKeepAlive', ['Prodoctsec']);
		} else {
			this.$store.commit('setKeepAlive', []);
		}
		next();
	},
	created() {
		const { selitem, producelist, getLangText } = this;

		producelist[0].text = getLangText(selitem, 'name');
		producelist[1].text = getLangText(selitem, 'brief');
		producelist[2].text = getLangText(selitem, 'apply');

		this.topimg = selitem.bigPicSJ;
		this.frontListFZ(selitem.id);
	},
	methods: {
		canNavigateFromThirdItem(item) {
			return canNavigateFromThirdItemUtil(item);
		},
		//选择三级分类
		Selsecpro(item) {
			this.Selfourpro(item);
			this.$refs.item.toggle();
		},
		//跳转四级页
		Todetail(item) {
			if (!this.canNavigateFromThirdItem(item)) {
				return;
			}
			localStorage.setItem('productFourItem', JSON.stringify(item));
			this.$router.push({
				name: 'Prodoctfour',
				query: {
					lang: this.lang
				}
			});
		},
		//选择四级产品
		Selfourpro(item) {
			this.selitem = item;
			this.profourlist = item.childrenProduct;
		},
		//产品信息接口
		frontListFZ(id) {
			let params = {
				parentId: id
			};
			getProductList(params).then(res => {
				this.prothirdlist = res;
				this.selitem = res[0];
				this.profourlist = res[0].childrenProduct;
			});
		}
	}
};
</script>

<style lang="scss">
@use './Prodoctthird.scss';
</style>
